import React from 'react';
import { useNavigate } from 'react-router-dom';
// ✅ Adjust these import paths based on where you save this file
import HeadingCard from '../../common/element/Card/HeadingCard';
import Button from '../../common/element/Buttons';
import Footer from './Footer'; 

const InvalidTokenPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#FFF1E6] flex flex-col items-center justify-center p-4">
      {/* Logo Section */}
      <div className="mb-8">
        <img 
          src="/assets/images/Logo-Incredible-Leaders.png" 
          width={200} 
          alt="Incredible Leaders" 
          onError={(e) => e.target.style.display = 'none'}
        />
      </div>

      <div className="w-full max-w-2xl flex-1 flex flex-col justify-center">
        <HeadingCard title="Link Invalid">
          <div className="text-center py-8">
            {/* Error Icon */}
            <div className="w-20 h-20 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-6">
              <svg width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22Z" stroke="#EF4444" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M15 9L9 15" stroke="#EF4444" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M9 9L15 15" stroke="#EF4444" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>

            {/* Message */}
            <p className="font-lato text-xl text-gray-800 mb-4 font-semibold">
              We couldn't recognize this assessment link.
            </p>
            <p className="font-lato text-gray-600 mb-8 px-4">
              The URL appears to be incomplete or incorrect. Please ensure you have copied the entire link provided in your email, or ask your administrator for a new one.
            </p>

            {/* Action Button */}
            <Button
              onClick={() => navigate('/')} 
              className="bg-[#FF8E1C] text-white px-8 py-3 rounded-[12px] font-bold shadow-[0px_2px_5px_#FFF4E5] hover:shadow-none transition-all"
            >
              Back to Home
            </Button>
          </div>
        </HeadingCard>
      </div>

      {/* <div className="mt-auto w-full">
        <Footer />
      </div> */}
    </div>
  );
};

export default InvalidTokenPage;